import * as DriveActions from '~app/actions/drive';
import createReducer from '~app/core/createReducer';

const initialState = {
  isApiLoaded:false,
  isSignedIn: false,
  files: [],
};

function apiLoaded(state, {isApiLoaded}){
  return {
    ...state,
    isApiLoaded,
  };
}

function signedIn(state, {isSignedIn}){
  return {
    ...state,
    isSignedIn,
  };
}

function filesListed(state, {files}){
  return {
    ...state,
    files,
  };
}

const ACTION_HANDLERS = {
  [DriveActions.DRIVE_API_LOADED]: apiLoaded,
  [DriveActions.GOOGLE_SIGN_IN ]: signedIn,
  [DriveActions.DRIVE_FILES_LISTED]: filesListed,
};

export default createReducer(ACTION_HANDLERS, initialState);



// WEBPACK FOOTER //
// ./src/reducers/drive.js